module.exports = __webpack_public_path__ + "static/media/mew-LOCAL.63e631dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/ethereum/mew-LOCAL.png
// module id = 1938
// module chunks = 147